<template>
  <a-modal
    :visible.sync="isDialogShow"
    width="400px"
    :mask-closable="false"
    :footer="null"
    :closable="true"
    class="notice-switch-tip-dialog"
    @cancel="isDialogShow=false"
  >
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: {
    sendUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isDialogShow: false
    }
  },
  methods: {
  }
}
</script>
